import { useMemo, useEffect } from 'react'
import { MarketplaceProduct } from '../types/marketplace-product'
import { Product } from '../types/product'
import { createProductDetailevent } from '../../shared/analytics/ecommerce-actions'
import { gtmTrack } from '../../shared/analytics/ga-tag-tracking'

const useTrackProductDetailsAnalytics = (
  product: MarketplaceProduct | Product | undefined
): void => {
  const productDetailevent = useMemo(() => {
    if (product instanceof MarketplaceProduct || !product?.sku) {
      return null
    }
    return createProductDetailevent(
      product.sku,
      product.constraints.minValue,
      product.constraints.maxValue
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(product as Product)?.sku])

  useEffect(() => {
    if (productDetailevent) {
      gtmTrack(productDetailevent)
    }
  }, [productDetailevent])
}

export default useTrackProductDetailsAnalytics
